module.exports = __webpack_public_path__ + "static/media/undraw-a-day-at-the-park-owg-1.894a9de2.svg";